var map = {
	"./about.png": "FhzR",
	"./banner/mob/img-dg.png": "8mil",
	"./banner/mob/img-gx.png": "8EXG",
	"./banner/mob/img-xzgt.png": "m8Lf",
	"./banner/mob/img-yybs.png": "vIHM",
	"./banner/pc/img-dg.png": "9AQV",
	"./banner/pc/img-gx.png": "VTmn",
	"./banner/pc/img-xzgt.png": "QEsU",
	"./banner/pc/img-yybs.png": "Z2QW",
	"./banner0.png": "V8MZ",
	"./banner1.png": "CMrX",
	"./banner2.png": "i4Cj",
	"./banner3.png": "XMCP",
	"./bg.png": "yRcn",
	"./bg2.png": "CjTQ",
	"./bg3.png": "VTmb",
	"./bg4.png": "fXWU",
	"./fgicon.png": "iF3I",
	"./footer-bg1.png": "cxUH",
	"./footer-bg2.png": "PInN",
	"./footer-logo.png": "DSQX",
	"./game-icon0.png": "/s8F",
	"./game-icon1.png": "Ucc6",
	"./game-icon2.png": "ho67",
	"./games/game-img-dg.png": "2HJ5",
	"./games/game-img-gx.png": "CB2M",
	"./games/game-img-xzgt.png": "mbyM",
	"./games/game-img-yybs.png": "SDs/",
	"./google.png": "fhOX",
	"./google2.png": "ef9L",
	"./h5-content-bg.png": "pYP9",
	"./hsimg.png": "Y13r",
	"./icon.png": "k3R8",
	"./icon0.png": "SMDe",
	"./icon1.png": "d0yY",
	"./icon2.png": "ceFa",
	"./index/h5-video-mark.png": "4CYC",
	"./index/img-dg.png": "+EzA",
	"./index/img-dg1.png": "A5qj",
	"./index/img-dg2.png": "evld",
	"./index/img-dg3.png": "GewJ",
	"./index/img-gx.png": "Fjrj",
	"./index/img-xzgt.png": "wJOf",
	"./index/img-yybs.png": "9E8O",
	"./index/pc-video-mark.png": "9bvs",
	"./ios.png": "8nfU",
	"./ios2.png": "ASh9",
	"./list-img0 - 副本 (2).png": "on1w",
	"./list-img0.png": "fPD8",
	"./list-img00.png": "Rx6a",
	"./list-img1.png": "bc5a",
	"./list-img12.png": "Z10O",
	"./list-img2.png": "Rc7G",
	"./list-img3.png": "AcEx",
	"./logo.png": "iQH9",
	"./logo2.png": "/eIm",
	"./news/1.png": "1Xip",
	"./next.png": "3aVt",
	"./pc-content-bg.png": "ca5q",
	"./prev.png": "xb5a",
	"./pro-img.png": "JhHx",
	"./sj-icon.png": "BgiZ",
	"./title-bottom.png": "jMvD",
	"./title-bottom2.png": "/yvk",
	"./web-but-1.png": "NajC",
	"./web-but-2.png": "38H9",
	"./web-but-3.png": "mz7t",
	"./web.png": "LhGE",
	"./yd-banner0.png": "1BjQ",
	"./yd-banner1.png": "M+n0",
	"./yd-banner2.png": "Oips",
	"./yd-banner3.png": "dCh7",
	"./yd-bg2.png": "Y+ls",
	"./yd-title-bottom.png": "kKFz"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tsha";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.png$
// module id = tsha
// module chunks = 0